import { render, staticRenderFns } from "./InstagramBusinessContentCard.vue?vue&type=template&id=72926e7f"
import script from "./InstagramBusinessContentCard.vue?vue&type=script&lang=js"
export * from "./InstagramBusinessContentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports